/**
 * Created by tdunham on 7/14/2017.
 */

import { Injectable }    from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable }    from 'rxjs/Observable';


/**
 * From the Angular tutorial.  https://angular.io/guide/router#cancel-and-save
 *
 * This is used to keep the user from navigating away from a page
 * that has been changed.
 *
 */
export interface CanComponentDeactivate {

	canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;

}

@Injectable()
export class CanDeactivateGuard implements CanDeactivate<CanComponentDeactivate> {

	canDeactivate(component: CanComponentDeactivate) {

		return component.canDeactivate ? component.canDeactivate() : true;

	}

}

/*
 Copyright 2017 Google Inc. All Rights Reserved.
 Use of this source code is governed by an MIT-style license that
 can be found in the LICENSE file at http://v2.angular.io/license
 */



// WEBPACK FOOTER //
// ./src/app/services/miscellaneous/can-deactivate-component.ts